module.exports = __webpack_public_path__ + "static/media/pega_correta.ab4fddd6.jpg";